import { FieldArray } from "formik";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Col, Label, Row } from "reactstrap";
import { CreateOfferContext } from "./context";
import SelectField from "../../Utils/SelectField";
import InputField from "../../Utils/InputField";
import {
  CycleAlignmentOption,
  pricingModelOptions,
  recurringFrequencyOptions,
  validityEndOptions,
  validityStartOptions,
  validityTimeOptions,
} from "./constants/initialValues";
import CommonDateTimePicker from "../../Utils/CommonDateTimePicker";
import moment from "moment";
import PricingModelTableRecurring from "./PricingModelTableRecurring";
import { LabelText } from "../../Utils/Input";
import Select from "react-select";

const BalanceImpactList = ({ pushRef, value, usageType, inx }) => {
  const {
    isEdit,
    setFieldValue,
    resourceNameOptions,
    uomOptions,
    isSubscribed,
    touched,
    errors,
    triggerError,
    attributes,
    chargeRules,
  } = useContext(CreateOfferContext);

  const canAddRow = (index) => {
    return value?.[index]?.pricingModelNew.every(
      (row) =>
        row.startingUnit !== "" &&
        row.endingUnit !== "" &&
        row.pricePerUnit !== ""
    );
  };

  const onChange = (rowIndex, key, val) => {
    const newData = [...value];
    newData[rowIndex][key] = val;

    setFieldValue(`${value[rowIndex]}`, newData);
    if (key === "pricingModel") {
      if (val.value === "volume") {
        canAddRow(rowIndex) && onAddPricingRow(rowIndex);
      }
    }
  };

  const onChangePricingModel = (rowIndex, key, modelIndex, val) => {
    const newData = [...value];
    if (!newData[rowIndex].pricingModelNew) {
      newData[rowIndex].pricingModelNew = [
        {
          startingUnit: "",
          endingUnit: "",
          pricePerUnit: "",
        },
      ];
    }
    newData[rowIndex].pricingModelNew[modelIndex][key] = val;
    setFieldValue(`${value[rowIndex]}`, newData);
  };

  const onAddPricingRow = (index) => {
    const newRow = [...value];
    newRow[index].pricingModelNew = [
      ...(newRow[index]?.pricingModelNew || []),
      {
        startingUnit: "",
        endingUnit: "",
        pricePerUnit: "",
      },
    ];
    setFieldValue(`${value[index]}`, newRow);
  };

  const attributeOptions = attributes
    ?.filter((attr) => attr?.type === "usage")
    ?.map((attr) => {
      return { label: attr.name, value: attr.name };
    });

  const chargeRuleOptions = chargeRules
    ?.map((chrg) => {
      return { label: chrg, value: chrg };
    });


  return (
    <FieldArray name="balanceImpacts">
      {({ push, remove }) => {
        pushRef.current = push;
        return (
          <div className="live-preview">
            {value.length === 0 ? (
              <div className="text-center">No Balance Impact Details</div>
            ) : (
              value?.map((val, index) => {
                // const keyIndex = value?.length - (index + 1);
                const keyIndex = index;

                return (
                  <div
                    key={index}
                    className="border-top border-opacity-50 rounded-0 mb-3"
                  >
                    {/* <Row className="mb-3 px-3 pt-3">
                      <Col
                        xs={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <h3 className="card-title mb-0">
                          Grant {keyIndex + 1}
                        </h3>
                        {!isEdit && (
                          <div>
                            <Link
                              to="#"
                              className="link-danger"
                              onClick={() => {
                                remove(keyIndex);
                              }}
                            >
                              <i
                                data-testid="delete"
                                className="ri-delete-bin-5-line"
                              ></i>
                            </Link>
                          </div>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mx-2 my-3">
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].resourceName`}>
                          Resource Name<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].resourceName`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.resourceName
                              : "Select Resource Name"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].resourceName`}
                          isDisabled={isSubscribed}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.resourceName) ||
                            false
                              ? "error-input"
                              : ""
                          } w-100`}
                          value={val?.resourceName}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "resourceName", selectedOption)
                          }
                          options={resourceNameOptions}
                          touched={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.resourceName
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].uom`}>
                          UOM
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].uom`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.uom
                              : "Select Unit of Measurement"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].uom`}
                          isDisabled={isSubscribed}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.uom) ||
                            false
                              ? "error-input"
                              : ""
                          } w-100`}
                          value={val?.uom}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "uom", selectedOption)
                          }
                          options={uomOptions}
                          touched={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.uom
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].flatRate`}>
                          Flat Rate
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].flatRate`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.flatRate &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.flatRate
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.flatRate &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.flatRate
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.flatRate
                              : "Enter Flat Rate"
                          }
                        />
                        <InputField
                          name={`balanceImpacts[${keyIndex}].flatRate`}
                          isDisabled={isSubscribed}
                          type="string"
                          className={`${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.flatRate &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.flatRate) ||
                            false
                              ? "is-invalid"
                              : ""
                          }`}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              ".",
                              "Tab",
                            ];
                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          handleChange={(e) =>
                            onChange(keyIndex, "flatRate", e.target.value)
                          }
                          value={val.flatRate}
                        />
                      </Col>
                      {usageType === "2" && (
                        <>
                          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                            <Label
                              for={`balanceImpacts[${keyIndex}].recurringFrequency`}
                            >
                              Recurring Frequency
                              <span className="text-danger"> *</span>
                            </Label>
                            <LabelText
                              htmlFor={`balanceImpacts[${keyIndex}].recurringFrequency`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequency &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequency
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequency &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequency
                                  ? errors?.recurringUsageRatePlan?.[inx]
                                      ?.balanceImpacts?.[keyIndex]
                                      ?.recurringFrequency
                                  : "Select Recurring Frequency"
                              }
                            />
                            <SelectField
                              name={`balanceImpacts[${keyIndex}].recurringFrequency`}
                              className={`${
                                isSubscribed
                                  ? "label-disable-color-edit-offer"
                                  : ""
                              } ${
                                (touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequency &&
                                  errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]
                                    ?.recurringFrequency) ||
                                false
                                  ? "error-input"
                                  : ""
                              } w-100`}
                              isDisabled={isSubscribed}
                              value={val?.recurringFrequency}
                              handleChange={(selectedOption) => {
                                onChange(
                                  keyIndex,
                                  "recurringFrequency",
                                  selectedOption
                                );
                              }}
                              options={recurringFrequencyOptions}
                              placeholder={" "}
                              isRVStyle={true}
                            />
                          </Col>
                          <Col xs={12} md={6} lg={6} xxl={3} className="mb-3">
                            <Label
                              for={`balanceImpacts[${keyIndex}].recurringFrequencyUnit`}
                            >
                              Recurring Frequency Unit
                              <span className="text-danger"> *</span>
                            </Label>
                            <LabelText
                              htmlFor={`balanceImpacts[${keyIndex}].recurringFrequencyUnit`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequencyUnit &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequencyUnit
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequencyUnit &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequencyUnit
                                  ? errors?.recurringUsageRatePlan?.[inx]
                                      ?.balanceImpacts?.[keyIndex]
                                      ?.recurringFrequencyUnit
                                  : "Enter Recurring Frequency Unit"
                              }
                            />
                            <InputField
                              name={`balanceImpacts[${keyIndex}].recurringFrequencyUnit`}
                              isDisabled={isSubscribed}
                              //    placeholder="Enter Recurring Frequency Unit"
                              type="string"
                              className={`${
                                (touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.recurringFrequencyUnit &&
                                  errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]
                                    ?.recurringFrequencyUnit) ||
                                false
                                  ? "is-invalid"
                                  : ""
                              }`}
                              handleChange={(e) =>
                                onChange(
                                  keyIndex,
                                  "recurringFrequencyUnit",
                                  e.target.value
                                )
                              }
                              value={val?.recurringFrequencyUnit}
                            />
                          </Col>
                          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                            <Label
                              for={`balanceImpacts[${keyIndex}].cycleAlignment`}
                            >
                              Cycle Alignment
                              <span className="text-danger"> *</span>
                            </Label>
                            <LabelText
                              htmlFor={`balanceImpacts[${keyIndex}].cycleAlignment`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.cycleAlignment &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.cycleAlignment
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.cycleAlignment &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.cycleAlignment
                                  ? errors?.recurringUsageRatePlan?.[inx]
                                      ?.balanceImpacts?.[keyIndex]
                                      ?.cycleAlignment
                                  : "Select Cycle Alignment"
                              }
                            />
                            <SelectField
                              name={`balanceImpacts[${keyIndex}].cycleAlignment`}
                              className={`${
                                isSubscribed
                                  ? "label-disable-color-edit-offer"
                                  : ""
                              } ${
                                (touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.cycleAlignment &&
                                  errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]
                                    ?.cycleAlignment) ||
                                false
                                  ? "error-input"
                                  : ""
                              } w-100`}
                              isDisabled={isSubscribed}
                              value={val?.cycleAlignment}
                              handleChange={(selectedOption) => {
                                onChange(
                                  keyIndex,
                                  "cycleAlignment",
                                  selectedOption
                                );
                              }}
                              options={CycleAlignmentOption}
                              placeholder={" "}
                              isRVStyle={true}
                            />
                          </Col>
                        </>
                      )}

                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label
                          for={`balanceImpacts[${keyIndex}].validityStart`}
                        >
                          Validity Starts
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].validityStart`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityStart &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityStart
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityStart &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityStart
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.validityStart
                              : "Select Validity Starts"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].validityStart`}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityStart &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.validityStart) ||
                            false
                              ? "error-input"
                              : ""
                          } w-100`}
                          isDisabled={isSubscribed}
                          value={val?.validityStart}
                          options={validityStartOptions}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "validityStart", selectedOption)
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>
                      {val?.validityStart?.value === 3 && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label
                            for={`balanceImpacts[${keyIndex}].startDateTime`}
                          >
                            Start Date and Time
                          </Label>
                          <LabelText
                            htmlFor={`balanceImpacts[${keyIndex}].startDateTime`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.startDateTime &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.startDateTime
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.startDateTime &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.startDateTime
                                ? errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]?.startDateTime
                                : "Select Start Date and Time"
                            }
                          />
                          <CommonDateTimePicker
                            type="datetime-local"
                            className={`${
                              isSubscribed
                                ? "label-disable-color-edit-offer"
                                : ""
                            } ${
                              (touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.startDateTime &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]
                                  ?.startDateTime) ||
                              false
                                ? "error-input"
                                : ""
                            } w-100`}
                            disabled={isSubscribed}
                            minDate={moment()}
                            handleChange={(newValue) =>
                              onChange(keyIndex, "startDateTime", newValue)
                            }
                            value={val?.startDateTime}
                            style={{
                              height: "38px",
                              fontSize: "0.875rem",
                              borderRadius: "0.5rem",
                            }}
                            placeholder={" "}
                          />
                        </Col>
                      )}

                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].validityEnd`}>
                          Validity Ends
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].validityEnd`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityEnd &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityEnd
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityEnd &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityEnd
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.validityEnd
                              : "Select Validity Ends"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].validityEnd`}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.validityEnd &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.validityEnd) ||
                            false
                              ? "error-input"
                              : ""
                          } w-100`}
                          isDisabled={isSubscribed}
                          value={val?.validityEnd}
                          options={validityEndOptions}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "validityEnd", selectedOption)
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>

                      {val?.validityEnd?.value === 3 && (
                        <>
                          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                            <Label
                              for={`balanceImpacts[${keyIndex}].timeValue`}
                            >
                              Time Value
                            </Label>
                            <LabelText
                              htmlFor={`balanceImpacts[${keyIndex}].timeValue`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeValue &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeValue
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeValue &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeValue
                                  ? errors?.recurringUsageRatePlan?.[inx]
                                      ?.balanceImpacts?.[keyIndex]?.timeValue
                                  : "Enter Time Value"
                              }
                            />
                            <InputField
                              name={`balanceImpacts[${keyIndex}].timeValue`}
                              className={`${
                                (touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeValue &&
                                  errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]?.timeValue) ||
                                false
                                  ? "is-invalid"
                                  : ""
                              }`}
                              disabled={isSubscribed}
                              //   placeholder="Enter Time Value"
                              type="text"
                              onKeyDown={(event) => {
                                const allowedKeys = [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  ".",
                                  "Tab",
                                ];
                                if (
                                  !/[0-9]/.test(event.key) &&
                                  !allowedKeys.includes(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              handleChange={(e) =>
                                onChange(keyIndex, "timeValue", e.target.value)
                              }
                              value={val?.timeValue}
                            />
                          </Col>
                          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                            <Label for={`balanceImpacts[${keyIndex}].timeUnit`}>
                              Time Unit
                            </Label>
                            <LabelText
                              htmlFor={`balanceImpacts[${keyIndex}].timeUnit`}
                              classLabelName={`d-block ms-0 rv-sub-label ${
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeUnit &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeUnit
                                  ? "rv-label-danger"
                                  : "rv-label-muted"
                              } `}
                              displayText={
                                touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeUnit &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeUnit
                                  ? errors?.recurringUsageRatePlan?.[inx]
                                      ?.balanceImpacts?.[keyIndex]?.timeUnit
                                  : "Select Time Unit"
                              }
                            />
                            <SelectField
                              name={`balanceImpacts[${keyIndex}].timeUnit`}
                              className={`${
                                isSubscribed
                                  ? "label-disable-color-edit-offer"
                                  : ""
                              } ${
                                (touched?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.timeUnit &&
                                  errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]?.timeUnit) ||
                                false
                                  ? "error-input"
                                  : ""
                              } w-100`}
                              isDisabled={isSubscribed}
                              value={val?.timeUnit}
                              options={validityTimeOptions}
                              handleChange={(selectedOption) =>
                                onChange(keyIndex, "timeUnit", selectedOption)
                              }
                              placeholder={" "}
                              isRVStyle={true}
                            />
                          </Col>
                        </>
                      )}
                      {val?.validityEnd?.value === 2 && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label
                            for={`balanceImpacts[${keyIndex}].endDateTime`}
                          >
                            End Date and Time
                          </Label>
                          <LabelText
                            htmlFor={`balanceImpacts[${keyIndex}].endDateTime`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.endDateTime &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.endDateTime
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.endDateTime &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.endDateTime
                                ? errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]?.endDateTime
                                : "Select End Date and Time"
                            }
                          />
                          <CommonDateTimePicker
                            type="datetime-local"
                            disabled={isSubscribed}
                            className={`${
                              isSubscribed
                                ? "label-disable-color-edit-offer"
                                : ""
                            } ${
                              (touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.endDateTime &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.endDateTime) ||
                              false
                                ? "error-input"
                                : ""
                            } w-100`}
                            minDate={moment()}
                            handleChange={(newValue) =>
                              onChange(keyIndex, "endDateTime", newValue)
                            }
                            value={val?.endDateTime}
                            style={{
                              height: "38px",
                              fontSize: "0.875rem",
                              borderRadius: "0.5rem",
                            }}
                            placeholder={" "}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].pricingModel`}>
                          Pricing Model<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].pricingModel`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.pricingModel &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.pricingModel
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.pricingModel &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.pricingModel
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.pricingModel
                              : "Select Pricing Model"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].pricingModel`}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.pricingModel &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.pricingModel) ||
                            false
                              ? "error-input"
                              : ""
                          } w-100`}
                          isDisabled={isSubscribed}
                          value={val?.pricingModel}
                          options={pricingModelOptions}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "pricingModel", selectedOption)
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>
                      {val?.pricingModel?.value === "threshold" && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label
                            for={`balanceImpacts[${keyIndex}].perUnitRate`}
                          >
                            Per Unit Rate
                          </Label>
                          <LabelText
                            htmlFor={`balanceImpacts[${keyIndex}].perUnitRate`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.perUnitRate &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.perUnitRate
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.perUnitRate &&
                              errors?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.perUnitRate
                                ? errors?.recurringUsageRatePlan?.[inx]
                                    ?.balanceImpacts?.[keyIndex]?.perUnitRate
                                : "Enter Per Unit Rate"
                            }
                          />
                          <InputField
                            name={`balanceImpacts[${keyIndex}].perUnitRate`}
                            disabled={isSubscribed}
                            className={`${
                              (touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex]?.perUnitRate &&
                                errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.perUnitRate) ||
                              false
                                ? "is-invalid"
                                : ""
                            }`}
                            //    placeholder="Enter Per Unit Rate"
                            type="text"
                            onKeyDown={(event) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                ".",
                                "Tab",
                              ];
                              if (
                                !/[0-9]/.test(event.key) &&
                                !allowedKeys.includes(event.key)
                              ) {
                                event.preventDefault();
                              }
                            }}
                            handleChange={(e) =>
                              onChange(keyIndex, "perUnitRate", e.target.value)
                            }
                            value={val?.perUnitRate}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].chargeRule`}>
                          Charge Rule
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].chargeRule`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeRule &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeRule
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.chargeRule
                              : "Enter Charge Rule"
                          }
                        />
                        <SelectField
                          name={`balanceImpacts[${keyIndex}].chargeRule`}
                          isDisabled={isSubscribed}
                          className={`${
                            isSubscribed ? "label-disable-color-edit-offer" : ""
                          } ${
                            (errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex] &&
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts &&
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex] &&
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeRule &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex].chargeRule)
                              ? "error-input"
                              : ""
                          } w-100`}
                          value={val?.chargeRule}
                          handleChange={(selectedOption) =>
                            onChange(keyIndex, "chargeRule", selectedOption)
                          }
                          options={chargeRuleOptions}
                          touched={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeRule
                          }
                          placeholder={" "}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xxs={12} md={6} className="mb-3">
                        <Label for={`balanceImpacts[${keyIndex}].chargeImpact`}>
                          Charge Impact
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`balanceImpacts[${keyIndex}].chargeImpact`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts &&
                              touched?.recurringUsageRatePlan?.[inx]
                                ?.balanceImpacts?.[keyIndex] &&
                              val?.chargeRule &&
                              (!val?.chargeImpact ||
                                val?.chargeImpact?.length === 0)) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeImpact &&
                            errors?.recurringUsageRatePlan?.[inx]
                              ?.balanceImpacts?.[keyIndex]?.chargeImpact
                              ? errors?.recurringUsageRatePlan?.[inx]
                                  ?.balanceImpacts?.[keyIndex]?.chargeImpact
                              : "Select Attributes"
                          }
                        />
                        <Select
                          isMulti
                          options={attributeOptions}
                          value={val?.chargeImpact}
                          onChange={(selected) =>
                            onChange(keyIndex, "chargeImpact", selected)
                          }
                          placeholder=" "
                          isDisabled={!val?.chargeRule}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderRadius: "0.5rem",
                              backgroundColor: !val?.chargeRule
                                ? "#EFF2F7"
                                : "white",
                              color: "black",
                              boxShadow: "none",
                              borderColor: "#ccc",
                              "&:hover": {
                                borderColor: "grey",
                              },
                              maxHeight: "30px",
                              overflowY: "auto",
                              flexWrap: "wrap",
                              fontWeight: "normal",
                              fontSize: "14px",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? "#f5f5f5"
                                : state.isSelected
                                ? "white"
                                : "white",
                              color: "black",
                              fontWeight: "normal",
                              fontSize: "14px",
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                filter: "brightness(0.95)",
                              },
                            }),
                            menu: (provided, state) => ({
                              ...provided,
                              fontWeight: "normal",
                              fontSize: "14px",
                              backgroundColor: state.isFocused
                                ? "#f5f5f5"
                                : state.isSelected
                                ? "white"
                                : "white",
                              color: "black",
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              backgroundColor: "#DFDFDF", // 🔹 tag background
                              borderRadius: "4px",
                              padding: "2px 6px",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              color: "black", // 🔹 text color inside the tag
                              fontWeight: 300,
                              fontSize: "13px",
                            }),
                            multiValueRemove: (provided) => ({
                              ...provided,
                              color: "black",
                              ":hover": {
                                backgroundColor: "#DFDFDF", // 🔹 hover color for remove icon
                                color: "black",
                              },
                            }),
                          }}
                        />
                      </Col>
                    </Row>

                    {val?.pricingModel?.value === "volume" && (
                      <PricingModelTableRecurring
                        pricingModelNew={val?.pricingModelNew || []}
                        onChangePricingModel={(key, idx, value) =>
                          onChangePricingModel(keyIndex, key, idx, value)
                        }
                        onAddRow={() => onAddPricingRow(keyIndex)}
                        onDeleteRow={(modelIndex) => {
                          const newRow = [...value];
                          newRow[keyIndex]?.pricingModelNew?.splice(
                            modelIndex,
                            1
                          );
                          setFieldValue(`${value[keyIndex]}`, newRow);
                        }}
                        isSubscribed={isSubscribed}
                        triggerError={triggerError}
                      />
                    )}
                  </div>
                );
              })
            )}
          </div>
        );
      }}
    </FieldArray>
  );
};

export default BalanceImpactList;
